import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import i18n from '~/i18n'

export const dateToString = (date, format = 'MMM DD YYYY H:mm') => {
  const lang = i18n.resolvedLanguage === 'zh' ? 'zh-cn' : 'en'

  return dayjs(date * 1000)
    .locale(lang)
    .format(format)
}

export const formatPrice = (price: number, precision: number) => {
  if (!price) return '0'

  if (price >= 100) {
    return Math.floor(price).toString()
  }

  if (price >= 1) {
    return (Math.floor(price * 100) / 100).toFixed(2)
  }

  // For price < 1, find first non-zero decimal digit
  const priceStr = price.toString()
  const [, decimals] = priceStr.split('.')
  let significantDigits = 0

  if (decimals) {
    for (let i = 0; i < decimals.length; i++) {
      if (decimals[i] !== '0') {
        significantDigits = i + 6 // Include 6 significant digits after first non-zero
        break
      }
    }
  }
  const finalPrecision = Math.min(significantDigits, precision)
  const multiplier = Math.pow(10, finalPrecision)
  return (Math.floor(price * multiplier) / multiplier).toFixed(finalPrecision)
}
